import * as React from "react";

function RelayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M10.688 19.13A7.25 7.25 0 0014.1 5.06M10.002 5.03a7.25 7.25 0 00-2.837 12.372M16.387 13.004a4.5 4.5 0 10-2.45 3.058M10.794 10.732a1.75 1.75 0 11.613 2.914"
  }));
}

export default RelayIcon;